import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title:
      "What is the difference between Vulnerability Management and Patch Management?",
    content: (
      <SimpleList
        points={[
          "Vulnerability Management identifies, assesses, and prioritizes security weaknesses.",
          "Patch Management deploys updates to fix vulnerabilities and prevent cyber exploits.",
        ]}
      />
    ),
  },
  {
    title: "How does AI improve vulnerability detection?",
    content: (
      <SimpleList
        points={[
          "AI analyzes global threat intelligence to identify and prioritize security risks in real-time.",
          "Detects zero-day vulnerabilities before attackers exploit them.",
          "Reduces false positives, ensuring IT teams focus on real threats.",
        ]}
      />
    ),
  },
  {
    title: "What happens if a patch fails or causes system instability?",
    content: (
      <SimpleList
        points={[
          "Rollback & Failover Protection allows businesses to revert to a stable version automatically.",
          "Pre-patch testing ensures minimal risk of compatibility issues.",
        ]}
      />
    ),
  },
  {
    title: "How does vulnerability scan work?",
    content: (
      <SimpleList
        points={[
          "AI-driven scanners continuously inspect networks, applications, and endpoints for security flaws.",
          "Risk assessments prioritize vulnerabilities based on severity and exploitability.",
          "Automated alerts notify IT teams of critical security gaps.",
        ]}
      />
    ),
  },
  {
    title: "How frequently should businesses perform vulnerability scans?",
    content: (
      <SimpleList
        points={[
          "Continuous scanning is recommended to detect vulnerabilities in real time.",
          "Critical infrastructure should be scanned daily, while less critical systems may be scanned weekly.",
        ]}
      />
    ),
  },
  {
    title: "Can automated patch management work across hybrid cloud environments?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind’s patch management works across on-prem, cloud, and hybrid IT environments, ensuring consistent security.",
        ]}
      />
    ),
  },
  {
    title: "What compliance regulations require vulnerability & patch management?",
    content: (
      <SimpleList
        points={[
          "SOC 2, ., PCI-DSS, ISO 27001, NIST, and GDPR mandate regular vulnerability assessments and timely patching.",
        ]}
      />
    ),
  },
  {
    title: "How does patch automation reduce IT workload?",
    content: (
      <SimpleList
        points={[
          "Eliminates manual patching efforts, reducing IT overhead.",
          "AI-powered automation deploys patches across multiple devices without downtime.",
          "Reduces risk exposure by applying security updates faster than manual processes.",
        ]}
      />
    ),
  },
  {
    title: "How does OneMind prioritize vulnerabilities for patching?",
    content: (
      <SimpleList
        points={[
          "Uses AI-powered risk analytics to focus on high-risk threats first.",
          "Considers exploitability, severity, and business impact before deploying patches.",
        ]}
      />
    ),
  },
  {
    title: "Can OneMind’s Patch Management integrate with existing ITSM tools?",
    content: (
      <SimpleList
        points={[
          "Yes! Seamlessly integrates with IT service management (ITSM), SIEM, and security tools for centralized patch orchestration.",
        ]}
      />
    ),
  },
  {
    title: "How does OneMind protect against zero-day vulnerabilities?",
    content: (
      <SimpleList
        points={[
          "Threat intelligence-driven detection identifies new exploits before they are widely used.",
          "Behavior-based security blocks zero-day threats before patches are available.",
        ]}
      />
    ),
  },
  {
    title: "Does OneMind’s solution support patching for third-party applications?",
    content: (
      <SimpleList
        points={[
          "Yes! Supports Windows, Linux, macOS, and third-party software, ensuring full-stack security.",
        ]}
      />
    ),
  },
];
